import React from 'react'
import { Skeleton } from '@material-ui/lab'

const LoaderGeneralEvent = () => {
  return (
    <div className="space-y-3">
      <Skeleton animation="wave" variant="text" className="mb-10" />
      <Skeleton animation="wave" variant="text" />
      <Skeleton animation="wave" variant="text" />
      <Skeleton animation="wave" variant="text" />
      <Skeleton variant="rect" width="full" height={118} />
      <Skeleton animation="wave" variant="text" />
      <Skeleton animation="wave" variant="text" />
      <Skeleton animation="wave" variant="text" />
      <Skeleton animation="wave" variant="text" />
      <Skeleton animation="wave" variant="text" />
    </div>
  )
}

export default LoaderGeneralEvent
